import React, { Component, useState } from "react";
import arrowdown from "../images/arrowdown.png"
import arrowup from "../images/arrowup.png"

const FaqSection = (props) => {
    const [collapse, setCollapse] = useState(false)
    const [faqColor, setFaqColor] = useState('#463642')
    const [boxColor, setboxColor] = useState(false)
    const collapsehendle = () => {
        if (collapse)  {
            setCollapse(false);
            setFaqColor('#463642')
        } else {
            setCollapse(true)
            setFaqColor('#000')
        }
    }


    return (
        <div>
            <div className="container" style={{ "maxWidth": "780px" }}>

            {collapse ? <>
                <div onClick={() => collapsehendle()} class="container faq1" style={{ backgroundColor: faqColor }} 
                 data-toggle="collapse" href={`#faqSection${props.index}`} role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                    <p  data-toggle="collapse" className="question" data-target={`#faqSection${props.index}`}>{props.question}<span><div>{collapse == true ? <img className="" src={arrowup}></img> : <img className="" src={arrowdown}></img>}</div></span></p>
                    {/* <p  data-toggle="collapse" className="question"> {collapse == true ? "-" : "+"} </p> */}
                </div>
            
            </> : <>
            <div onClick={() => collapsehendle()} class="container faq" style={{ backgroundColor: faqColor }} 
                 data-toggle="collapse" href={`#faqSection${props.index}`} role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                    <p  data-toggle="collapse" className="question" data-target={`#faqSection${props.index}`}>{props.question}<span><div>{collapse == true ? <img className="" src={arrowup}></img> : <img className="" src={arrowdown}></img>}</div></span></p>
                    {/* <p  data-toggle="collapse" className="question"> {collapse == true ? "-" : "+"} </p> */}
                </div>
            
            </>}
                
                <div class="collapse multi-collapse" id={`faqSection${props.index}`}>
                    <div class="answere px-3">{props.answere}</div>
                </div>



            </div>
        </div>

    );
}
export default FaqSection;